<template>
    <div class="delivery-maintain-set-detail">
        <el-row class="device-drink-title">
            <el-col :span="5">
                <span class="h3">维护信息编辑</span>
                <router-back/>
            </el-col>
        </el-row>
        <div class="screen-maintain-set-data">
            <el-tabs :tab-position="'left'" class="device-maintain-set-config" v-model="activeName">
                <el-tab-pane label="费用配置" name="fee">
                    <el-form label-width="160px" size="mini">
                        <el-form-item label="维护名称">
                            <el-input v-model="maintain.name" placeholder="请输入维护名称"/>
                        </el-form-item>
                        <el-form-item label="设备周期计费上限(元)">
                            <el-input size="mini" v-model="maintain.maxFee"
                                      @change="maintain.maxFee=materielExtraCostChange(maintain.maxFee)"></el-input>
                        </el-form-item>
                        <el-form-item label="设备计费重置周期(天)">
                            <el-input size="mini" v-model.number="maintain.resetPeriod"></el-input>
                        </el-form-item>
                        <el-form-item label="工作时间">
                            <el-time-select
                                    placeholder="起始时间"
                                    v-model="startTime"
                                    :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00'
                        }">
                            </el-time-select>
                            <el-time-select
                                    placeholder="结束时间"
                                    v-model="endTime"
                                    :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00',
                          minTime: startTime
                        }">
                            </el-time-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" plain @click="updateDeviceParamTmpl">保存配置</el-button>
                        </el-form-item>

                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="参数配置" name="param">
                    <el-button size="mini" type="primary" plain class="save-param" @click="saveTmplParams">保存参数
                    </el-button>
                    <el-button size="mini" type="primary" plain @click="applyDeviceParam" class="save-param">设备应用参数
                    </el-button>
                    <div class="delivery-maintain-set-param">
                        <maintain-param :params="params"></maintain-param>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div>
                <span class="device-title">{{$t('xiang_guan_she_bei')}}</span>
                <el-button size="mini" type="primary" @click="allocatedVisible=true">{{$t('bang_ding_she_bei')}}</el-button>
                <el-button size="mini" type="primary" @click="resetDeviceFee">重置设备费用</el-button>
            </div>
            <div class="delivery-maintain-set-device-list">
                <el-table :data="devices">
                    <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="name"></el-table-column>
                    <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="uuid"></el-table-column>
                    <el-table-column :label="$t('chan_pin_ming_chen')" align="center" prop="productName"></el-table-column>
                    <el-table-column label="剩余费用额度(元)" align="center" prop="curFee">
                        <template slot-scope="scope">
                            <span>{{scope.row.curFee / 100 | F1000 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="最近一次重置时间" align="center">
                        <template slot-scope="scope">
                            <span>{{new Date(scope.row.resetAt * 1000).Format('yyyy-MM-dd hh:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="重置额度周期(天)" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.restPeriod / (24 * 3600)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
                        <template slot-scope="scope">
                        <span @click="handleDelete(scope.row)"
                              class="device-screen-saver-edit">{{$t('shan_chu')}}</span>

                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @current-change="handleCurrentChange"
                        class="pagination"
                        :current-page="pagination.curPage"
                        :page-size="pagination.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="pagination.total">
                </el-pagination>
            </div>

        </div>

        <c-dialog class="dialog" :visible.sync="allocatedVisible" :width="'50rem'" :height="'37.5rem'"
                  :outer-close="false"
                  title="分配设备">

            <el-button slot="title" size="mini" type="primary" @click="deviceAllocate">{{$t('bao_cun')}}</el-button>

            <allocation-device ref="allocDevice" slot="default"></allocation-device>
        </c-dialog>

    </div>

</template>

<script>
    import CDialog from '@/components/Dialog'
    import AllocationDevice from '@/components/AllocateDevice'
    import MaintainParam from './maintainParam'
    import {
        maintainSetDeviceParamTmplUpdate,
        maintainSetDeviceParamTmplParam,
        maintainSetDeviceParamTmplParamUpdate,
        maintainSetDeviceParamTmplDeviceUnion,
        maintainSetDeviceParamTmplDeviceList,
        maintainSetDeviceParamTmplDeviceBind,
        maintainSetDeviceParamTmplDeviceUnBind,
        maintainSetDeviceParamTmplDeviceResetFee,
        maintainSetDeviceParamTmplDeviceApplyParam,
    } from '@/api/delivery/device/maintainSet'
    export default {
        name: '',
        components: {
            CDialog,
            AllocationDevice,
            MaintainParam
        },
        activated: function () {
            this.pagination.uuid = this.$route.params.uuid
            for (let item in this.$route.params) {
                if (this.maintain.hasOwnProperty(item)) {
                    this.maintain[item] = this.$route.params[item]
                }
            }
            this.startTime = `${this.maintain.startHour}:${this.maintain.startMinute}`
            this.endTime = `${this.maintain.endHour}:${this.maintain.endMinute}`
            this.loadDevices()
            maintainSetDeviceParamTmplParam({uuid: this.pagination.uuid}).then(res => {
                this.params = res.data || []
            })
        },
        data: function () {
            return {
                maintain: {
                    uuid: '',
                    name: '',
                    maxFee: 0.00,
                    resetPeriod: 0,
                    startHour: 0,
                    startMinute: 0,
                    endHour: 0,
                    endMinute: 0,
                },
                startTime: '00:00',
                endTime: '00:00',
                devices: [],
                allocatedVisible: false,
                activeName: 'fee',
                pagination: {
                    uuid: '',
                    start: 0,
                    curPage: 1,
                    limit: 10,
                    total: 0,
                },
                params: []
            }
        },
        methods: {
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                maintainSetDeviceParamTmplDeviceList(this.pagination).then(res => {
                    this.devices = res.data
                })
            },

            updateScreenSaver() {
                this.$refs.mulUpload.handleUpload()
            },

            deviceAllocate(){
                let vue = this
                let devices = vue.$refs.allocDevice.deviceAllocate()
                if (!devices.length) {
                    this.$message.warning('请选取需要分配的设备')
                } else {
                    maintainSetDeviceParamTmplDeviceBind({
                        uuid: this.pagination.uuid,
                        deviceUuids: devices
                    }).then(() => {
                        vue.loadDevices()
                        vue.allocatedVisible = false
                    })
                }
            },

            saveTmplParams(){
                maintainSetDeviceParamTmplParamUpdate({uuid: this.pagination.uuid, params: this.params}).then(res => {
                    this.$message.success('更新成功')
                })
            },

            loadDevices() {
                let vue = this
                maintainSetDeviceParamTmplDeviceUnion(this.pagination).then(res => {
                    vue.devices = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },


            handleDelete(row) {
                this.$confirm('此操作将删除设备屏保, 是否继续?', this.$t('ti_shi'), {
                    confirmButtonText: this.$t('que_ding'),
                    cancelButtonText: this.$t('qu_xiao'),
                    type: 'warning'
                }).then(() => {
                    maintainSetDeviceParamTmplDeviceUnBind({
                        deviceUuid: row.uuid,
                        uuid: this.pagination.uuid
                    }).then(res => {
                        if (res.code === 0) {
                            this.$message.success('移除成功')
                            this.loadDevices()
                        }
                    })
                }).catch(() => {

                })
            },

            materielExtraCostChange(item) {
                // 防止删除为空
                if (!item) {
                    item = '0.00'
                }
                // 一些错误金额输入的判断
                if (item.toString().indexOf('.') > 0 && Number(item.toString().split('.')[1].length) < 1) {
                    item = item.toString().split('.')[0]
                }
                // 一些错误金额输入的判断
                if (!item || item === '-' || item === '-0') {
                    item = '0.00'
                }

                return parseFloat(item).toFixed(2)
            },

            resetDeviceFee() {
                maintainSetDeviceParamTmplDeviceResetFee({uuid: this.pagination.uuid}).then(
                    () => {
                        this.loadDevices()
                        this.$message.success('重置成功')
                    })
            },

            applyDeviceParam() {
                maintainSetDeviceParamTmplDeviceApplyParam({uuid: this.pagination.uuid}).then(
                    () => this.$message.success('设备参数已应用'))
            },

            updateDeviceParamTmpl() {
                if (this.maintain.name.length === 0) {
                    this.$message.warning('请输入饮品名称')
                    return
                }

                if (this.startTime.length === 0) {
                    this.$message.warning('请选取开始工作时间')
                    return
                }

                if (this.endTime.length === 0) {
                    this.$message.warning('请选取结束工作时间')
                    return
                }

                let start = this.startTime.split(`:`)
                let end = this.endTime.split(`:`)

                let maintain = {
                    uuid: '',
                    name: '',
                    maxFee: 0.00,
                    resetPeriod: 0,
                }

                for (let item in this.maintain) {
                    if (maintain.hasOwnProperty(item)) {
                        maintain[item] = this.maintain[item]
                    }
                }

                maintain.startHour = parseInt(start[0])
                maintain.startMinute = parseInt(start[1])
                maintain.endHour = parseInt(end[0])
                maintain.endMinute = parseInt(end[1])
                maintain.resetPeriod = maintain.resetPeriod * 24 * 3600
                maintain.maxFee = parseFloat(maintain.maxFee) * 100
                maintainSetDeviceParamTmplUpdate(maintain).then(() => {
                    this.$message.success('更新成功')
                })
            }
        },
    }
</script>

<style lang="scss">
    .delivery-maintain-set-detail {
        padding: 0 $padding;

        .device-maintain-set-config {
            padding: $padding 0;
            height: 22rem;

            .delivery-maintain-set-param {
                height: 18rem;
                overflow-y: scroll;
            }

        }

        .el-button--danger.is-plain, .el-button--primary.is-plain {
            background-color: transparent;
        }

        .el-form {
            width: 60%;
            min-width: 240px;

        }

        .save-param {
            margin-bottom: $padding;
            margin-left: $padding-5;
        }

        .device-screen-saver-edit {
            color: $btn_sec_color;
            cursor: pointer;
        }

        .device-title {
            margin-right: $padding;
        }

        .delivery-maintain-set-device-list {
            flex: 1;
        }

    }
</style>
